import {
  GET_LIST_CONTACT_DATA, GET_LIST_CONTACT_PERSON_DATA, GET_LIST_CONTACT_COMPANY_DATA, GET_LIST_NOT_LINKED_USER_DATA,
  GET_LIST_CONTACT_PERSON_INTERNAL_DATA, GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA, GET_LIST_DEAL_DATA,
  GET_LIST_ACTIVITY_DEAL_DATA, GET_LIST_DEAL_ASSET_DATA, GET_LIST_CONTACT_NOT_PARTICIPANT_DATA, GET_LIST_TAG_DATA,
} from '../../../constants/system/actions';

const getListContactData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_CONTACT_DATA, payload, resolve, reject,
});

const getListContactPersonData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_CONTACT_PERSON_DATA, payload, resolve, reject,
});

const getListContactCompanyData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_CONTACT_COMPANY_DATA, payload, resolve, reject,
});

const getListContactPersonInternalData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_CONTACT_PERSON_INTERNAL_DATA, payload, resolve, reject,
});

const getListContactNotParticipantData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_CONTACT_NOT_PARTICIPANT_DATA, payload, resolve, reject,
});

const getListDealTaskContactPersonData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA, payload, resolve, reject,
});

const getListNotLinkedUserData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_NOT_LINKED_USER_DATA, payload, resolve, reject,
});

const getListDealData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_DEAL_DATA, payload, resolve, reject,
});

const getListActivityDealData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_ACTIVITY_DEAL_DATA, payload, resolve, reject,
});

const getListDealAssetData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_DEAL_ASSET_DATA, payload, resolve, reject,
});

const getListTagData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_LIST_TAG_DATA, payload, resolve, reject,
});

export {
  getListContactData,
  getListContactPersonData,
  getListContactCompanyData,
  getListContactPersonInternalData,
  getListContactNotParticipantData,
  getListDealTaskContactPersonData,
  getListNotLinkedUserData,
  getListDealData,
  getListActivityDealData,
  getListDealAssetData,
  getListTagData,
};
